import { getReturnUrl } from "@/utils/cookies";
import styles from "./error.module.scss";
import { useTranslation } from "react-i18next";

interface ErrorPageProps {
    message?: string;
}

/**
 * Basic error page component that can be rendered from anywhere in the application.
 */
export const ErrorPage = ({ message }: ErrorPageProps) => {
    const { t } = useTranslation();
    const returnUrl = getReturnUrl(import.meta.env.VITE_WEBAUTO_LOGIN);

    return (
        <div className={styles.container}>
            <div id="error-page">
                <h1>{t('oops')}</h1>
                <p>{t('errorOccured')}</p>
                {message &&
                    <p>
                        <i>{message}</i>
                    </p>
                }
            </div>
            <div className={styles.footer}>
                <a href={returnUrl}>{t('goBack')}</a>
            </div>
        </div>
    );
}

export default ErrorPage;